import { FC } from 'react';
import { ReactPlayerProps } from 'react-player';
import { Video } from 'atoms/Video';
import { YoutubePlayButton } from './YoutubePlayButton';
import styles from './styles.module.css';

export const YoutubePlayer: FC<ReactPlayerProps> = ({ url, ...props }) => {
  return (
    <Video
      url={url}
      light
      playIcon={<YoutubePlayButton />}
      controls
      className={styles.player}
      {...props}
    />
  );
};
